export enum PermissionType {
  Edit = "Edit",
  View = "View",
  NotAllow = "NotAllow",
  SyncToMainTable = "SyncToMainTable",
}
